module.exports = __webpack_public_path__ + "img/8af130b.jpg";